import React from 'react'
import { FiX } from 'react-icons/fi'

export const ProjectStatus = () => {
    return (
        <div className="badger">
            <p>  message.title  </p> 
            <p> ownership </p>
            <div className="flex-start ">
                <a className="button" href={`/assets/images/projects/edit/1`} rel="noreferrer"> Edit </a>
                <div className="hidden">
                    <div className="button">Leave</div>
                    <div>
                      <FiX />
                    </div>
                </div>
            </div>
        </div>
    ) 
}


